class ModalVideo extends HTMLElement {
  constructor () {
    super()

    this.modalTriggerEl = document.querySelector(
      '[data-el="modal-video.modal-trigger"]'
    )
    this.modalCloseEls = this.querySelectorAll(
      '[data-el="modal-video.modal-close"]'
    )
    this.modalVideoEls = this.querySelectorAll(
      '[data-el="modal-video.modal-video"]'
    )

    this.setupVideoModal()
  }

  setupVideoModal () {
    if (!this.modalTriggerEl) return

    this.modalTriggerEl.addEventListener(
      'click',
      this.handleModalTrigger.bind(this)
    )
    this.modalCloseEls.forEach(modalCloseEl => {
      modalCloseEl.addEventListener('click', this.handleModalClose.bind(this))
    })
    this.addEventListener('click', e => {
      if (e.target !== this) return

      this.setAttribute('aria-hidden', 'true')
      this.modalVideoEls.forEach(modalVideoEl => {
        modalVideoEl.pause()
      })
    })
  }

  handleModalTrigger = event => {
    this.setAttribute('aria-hidden', 'false')
  }

  handleModalClose = event => {
    this.setAttribute('aria-hidden', 'true')
    this.modalVideoEls.forEach(modalVideoEl => {
      modalVideoEl.pause()
    })
  }
}

customElements.define('modal-video', ModalVideo)
